import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useUpdateDrugQuote = () => {
    const { mutate: updateDrugQuote, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.put('/drugsearch/updatequote', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message =
                    data?.message ?? data?.data?.message ?? 'Drug quote updated successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to update drug quote';
                toast.error(errorMessage);
            },
        }
    );

    return {
        updateDrugQuote,
        isUpdateDrugQuoteLoading: isLoading,
    };
};

export default useUpdateDrugQuote;
